// extracted by mini-css-extract-plugin
module.exports = {"toggle":"clinical-portal-3__Toggle__toggle","slider":"clinical-portal-3__Toggle__slider"};